

























































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import vueformmodel from "../../../lib/vueformmodel";
import { FormItem } from "view-design";
@Component
export default class suppliermanageaddoredit extends vueformmodel {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number | undefined;

    get prox() {
        return new proxy.FinanceManageServiceProxy();
    }

    merchant = {} as any;
    startTime = new Date(new Date(new Date().toLocaleDateString()).getTime());
    endTime = new Date(
        new Date(new Date().toLocaleDateString()).getTime() + 3600 * 1000 * 24
    );
    yesterdayTime = new Date(
        new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24
    );
    reqMer = {} as any;
    merchantStatistics = {} as any;
    merchantChannelTypeStatistics = [];

    reqChannelType = {} as any;
    channelTypeStatistics = []
    channelTypeColumns = [
        {
            title: '平台产品',
            key: 'channelTypeName'
        },
        {
            title: '总单量',
            key: 'totalOrderNum'
        },
        {
            title: '成功单量',
            key: 'successOrderNum'
        },
        {
            title: '成交额',
            key: 'successAmount'
        },
        {
            title: '服务费',
            key: 'commission'
        },
        {
            title: '成功率(%)',
            key: 'successRate'
        }
    ]

    reqChannel = {} as any;
    channelStatistics = [];
    channelColumns = [
        {
            title: '上游通道',
            key: 'channelName'
        },
        {
            title: '总单量',
            key: 'totalOrderNum'
        },
        {
            title: '成功单量',
            key: 'successOrderNum'
        },
        {
            title: '成交额',
            key: 'successAmount'
        },
        {
            title: '服务费',
            key: 'channelRateCommission'
        },
        {
            title: '成功率(%)',
            key: 'successRate'
        }
    ]

    save() {
        this.$emit("input", false);
    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.reqMer.merchantId = this.id;
            this.reqMer.createTime = this.startTime;
            this.reqMer.endTime = this.endTime;
            this.reqChannelType.createTime = this.startTime;
            this.reqChannelType.endTime = this.endTime;
            this.reqChannelType.merchantId = this.id;
            this.reqChannel.createTime = this.startTime;
            this.reqChannel.endTime = this.endTime;
            this.reqChannel.merchantId = this.id;
            this.queryMerchantStatistics();
            this.prox.queryMerchantTypeStatistics(this.id).then(x => {
                this.merchantChannelTypeStatistics = x;
            })
            new proxy.MerchantServiceProxy().queryModel(this.id).then(x => {
                this.merchant = x;
            })
        }
    }

    todayStatistics() {
        this.reqMer.createTime = this.startTime;
        this.reqMer.endTime = this.endTime
        this.reqChannelType.createTime = this.startTime;
        this.reqChannelType.endTime = this.endTime
        this.reqChannel.createTime = this.startTime;
        this.reqChannel.endTime = this.endTime;
        this.queryMerchantStatistics();
    }

    yesterdayStatistics() {
        this.reqMer.createTime = this.yesterdayTime;
        this.reqMer.endTime = this.startTime;
        this.reqChannelType.createTime = this.yesterdayTime;
        this.reqChannelType.endTime = this.startTime;
        this.reqChannel.createTime = this.yesterdayTime;
        this.reqChannel.endTime = this.startTime;
        this.queryMerchantStatistics()
    }

    queryMerchantStatistics() {
        console.log(123123)
        this.prox.zhuYeQueryMerchantStatistics(this.reqMer).then((x) => {
            
            if (x && x.length) {
                this.merchantStatistics = x[0];
            } else {
                this.merchantStatistics = {};
            }
        });
        this.prox.singleQueryMerchantChannelTypeStatistics(this.reqChannelType).then(x => {
            this.channelTypeStatistics = x;
        })
        this.prox.singleQueryMerchantChannelStatistics(this.reqChannel).then(x => {
            this.channelStatistics = x;
        })
    }

    roleRule = {};
}
